var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"steps"},[_c('span',{staticClass:"line"}),_vm._l((_vm.data),function(item,index){return _c('p',{key:index,staticClass:"row",class:{active: _vm.step > index}},[_c('span',{staticClass:"step"},[_c('img',{attrs:{"src":item.src,"alt":""}})]),_c('span',{staticClass:"name"},[_vm._v(_vm._s(item.name))])])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }